const navbarItems = [
  {
    title: 'About me',
    link: '/',
  },
  {
    title: 'My work',
    link: '/work',
  },
  {
    title: 'Lab',
    link: '/lab',
  },
  {
    title: 'Contact',
    link: '/contact',
  },
];

export default navbarItems;
